import { getDateMonthTimeFromTimestamp } from "@/lib/utils";

const ServiceTaskData = ({
	taskHistory,
}: {
	taskHistory: Task;
	index: number;
	toggleArrow: (indx: number) => void;
	expandedSections: Record<string, unknown>;
}) => {
	return (
		<>
			<div className="flex-1">
				<div className="flex items-center justify-between">
					<div>
						<div className="flex flex-col">
							<span className="text-sm text-gray-400">
								<strong>Workflow current step:</strong>{" "}
								{taskHistory?.variables.workflow_current_step}
							</span>
							<span className="text-sm text-gray-400">
								<strong>Status:</strong>{" "}
								{taskHistory?.variables.workflow_current_step_status
									? taskHistory?.variables.workflow_current_step_status
									: "pending"}
							</span>

							{taskHistory?.variables.workflow_current_step_status ===
								"failed" && (
								<span className="text-sm text-gray-400">
									<strong>Error Message: </strong>{" "}
									{taskHistory?.variables.workflow_current_step_error}
								</span>
							)}

							<span className="text-sm text-gray-400">
								{taskHistory?.date &&
									getDateMonthTimeFromTimestamp(taskHistory?.date)}
							</span>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ServiceTaskData;
